function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { connect } from "react-redux";
import Component from "../components/AppFooter";
import { setUIVisibilityState, setStoryMode, sendNotification } from "../actions";
import findIndex from "lodash/findIndex";
var mapStateToProps = function(state, _ownProps) {
    var _state_cbook;
    var slideNodes = state.nodes.filter(function(n) {
        return n.target_type !== "Filter";
    });
    var currentIndex = findIndex(slideNodes, {
        id: state.currentSlide
    }) > -1 ? findIndex(slideNodes, {
        id: state.currentSlide
    }) : 0;
    var trackable = slideNodes.filter(function(n) {
        return !n.do_not_track;
    });
    var slideNode = slideNodes[currentIndex];
    return {
        engagementServerEnabled: (_state_cbook = state.cbook) === null || _state_cbook === void 0 ? void 0 : _state_cbook.can_use_engagement_server,
        cbookMode: state.cbook && state.cbook.mode,
        currentSlideType: slideNode && slideNode.target_type,
        currentSlideCompleted: !!(slideNode && state.completed.indexOf(slideNode.id) > -1),
        maxCharts: slideNodes.length,
        visitedChartsCount: state.completed.length,
        currentChartIndex: currentIndex,
        trackableMaxCharts: trackable.length || 1,
        trackableVisitedChartsCount: state.completeable ? trackable.filter(function(n) {
            return state.completed.indexOf(n.id) > -1;
        }).length : 1,
        storyMode: state.storyMode,
        isLoading: state.loading.indexOf("fetch_locale") > -1 || state.loading.indexOf("fetch_cbook") > -1,
        uiVisibilityState: state.uiVisibilityState,
        navDisabled: !!(state.exam && state.exam.state === "running"),
        bonusDisabled: !!(!!slideNode && slideNode.allow_bonus_material === "never"),
        notesDisabled: !!slideNode && slideNode.allow_notes === "never",
        activityDisabled: !!slideNode && slideNode.allow_activity_center === "never",
        bmCount: slideNode ? state.bonusMaterial.filter(function(bm) {
            return bm.owner.type === slideNode.target_type && bm.owner.id === slideNode.target_id;
        }).length : 0,
        quickNavHideMenu: !!(state.cbook && state.cbook.quick_nav_hide_menu),
        quickNav: !!state.cbook && !!state.cbook.quick_nav,
        isLoadingGroups: state.loading.indexOf("fetch_groups") > -1,
        topics: state.topics
    };
};
var mapDispatchToProps = function(dispatch, _ownProps) {
    return {
        setUIVisibilityState: function(visibilityState) {
            dispatch(setUIVisibilityState({
                state: visibilityState
            }));
        },
        setStoryMode: function(storyMode, nodeType, navigationMode, completed, navDisabled) {
            if (navDisabled) {
                dispatch(sendNotification({
                    key: "action_not_allowed_while_exam",
                    message: "action_not_allowed_while_exam",
                    label: ""
                }));
                return;
            }
            if (!storyMode && navigationMode === "linear" && nodeType && !/(^Page|Template|Extension)/.test(nodeType) && !completed) {
                dispatch(sendNotification({
                    key: "storyModeSwitched",
                    message: "navigation.complete_in_storyMode",
                    label: "ui.attention",
                    notificationType: "warning"
                }));
            }
            dispatch(setStoryMode({
                storyMode: storyMode
            }));
        },
        notify: function(id) {
            var messageProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            dispatch(sendNotification({
                key: "ui.".concat(id),
                label: "",
                message: id,
                messageProps: messageProps
            }));
        }
    };
};
var mergeProps = function(stateProps, dispatchProps, ownProps) {
    return _objectSpreadProps(_objectSpread({}, ownProps, stateProps, dispatchProps), {
        setStoryMode: function(storyMode) {
            dispatchProps.setStoryMode(storyMode, stateProps.currentSlideType, stateProps.cbookMode, stateProps.currentSlideCompleted, stateProps.navDisabled);
        }
    });
};
export default connect(mapStateToProps, mapDispatchToProps, mergeProps, {
    pure: false
})(Component);
